// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_QD6ZG","box":"index_box_nhDYx","close":"index_close_WaZjR","page":"index_page_Mi5hZ"};